module.exports = __webpack_public_path__ + "static/media/MZW_03.c971fbeb.jpg";